module.exports = __webpack_public_path__ + "static/assets/2d864963fd2e97abc24f77a62b965b73.png";